module.exports = __webpack_public_path__ + "img/caret-square-right.29bdd2d7.svg";